"use client";

import "./MobileContactSection.scss";
import ContactForm from "@/components/ContactForm/ContactForm";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const MobileContactSection = ({ contact }) => {
  const { title, description } = contact;
  return (
    <section className="mobile-cta-section">
      <Container>
        <Row className="align-items-center">
          <Col xxl={6} xl={6} lg={6}>
            <div className="erp-cta-content">
              <h2>{title}</h2>
              <p>{description}</p>
            </div>
          </Col>

          <Col xxl={6} xl={6} lg={6} data-aos="zoom-in">
            <ContactForm />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default MobileContactSection;
